'use strict';

if (!window.i18n) {
	window.i18n = {};
}

if (!window.i18n.languages) {
	window.i18n.languages = {};
}

window.i18n.languages['ko_KO'] = {
	vistor_upsucess:"업데이트 성공",
	vistor_accountUp:"계정 업그레이드",
	vistor_upgradeNow:"즉시 업그레이드",
	vistor_dear:"방문자 여러분 :",
	vistor_suggest:"안녕하세요, 더 나은 사용자 경험을 제공하기 위해 다음을 제안합니다.",
	vistor_click:"공식 계정으로 업그레이드하려면 아래 \"계정 업그레이드\"를 클릭하세요.",
	vistor_sorry:"죄송합니다. 게스트 계정은 비밀번호를 변경할 수 없습니다. 계정 보안을 위해 공식 계정으로 업그레이드하세요.",

	change_useridpwd:"계정 확인",
	bizhong_xuanze: "통화 선택",

	optional:"선택 과목",
	needBet: "여전히 내기:",
	needDeposit:"보증금 필요:",
	agentCode : "초대 코드",
	tips_fail:"청구 실패",
	a_stauts: "이벤트상태",
	activityDetails_hdjxz: "이벤트진행중",
	activityDetails_hdwks: "이벤트가 아직 시작되지 않음",
	activityDetails_hdyjs: "이벤트 결속 ",

	a_time: `활동 시간`,
	a_status: `활성 상태`,
	a_rule: `보상 규칙`,
	a_content: `활동 내용`,

	gameCoin:"게임 화폐",
	register_chooseCurrency: "입금 통화 선택",
	register_tips0:"*등록 후 통화 변경은 허용되지 않습니다.",
	register_curInstruction:"통화 설명 :",
	register_tips1:"1. 사용자의 현재 통화를 지원하지 않는 게임에 입장 할 때,환율로 변환 된 금액이 게임에 반영됩니다.",
	register_tips2:"2. 사용자의 입 / 출금 방법은 사용자의 현재 통화 지원을 표시하는 것입니다.",

	sendSuccess:"성공적으로 보냈습니다!",
	login_areaCode: '국가 코드',
	login_selectAreaCode: '국가 또는 지역 선택',
	new_maxVipLV: '축하합니다! ! 현재 최고 수준입니다.',
	currency_symbol : "₩",
	language : "한국어",

	new_r_rate: '게임에 투입되는 금액은 환율 환산 후의 금액입니다.',
	new_r_rate1: '환율：',
	new_r_money: '게임 내 금액：',
	new_r_tips6: '* 3 자 게임 으로 넘 어가 면 정수 만 들 어 갈 수 있 으 니 주의 하 세 요.',
	new_r_tips7: '환율 알림',
	new_r_tips8: '알아',
	new_r_tips9: '현재는',
	new_r_game : "게임 들어갑니다",

	"ActivityNew": {
		"btn_lingqu": "지금 당장 받아",
		"btn_back": "반환",
		"toggle_zonghe": "포괄적 인 활동",
	},

	"SignIn": {
		"btnLingqu": "받다",
	},

	"label_text": {
		"title": "보상 받기",
		"loading_msg": "업데이트 리소스 팩 다운로드",
		"not_logged": "로그인하지 않았습니다",
		"password": "암호:",
		"verify": "확인 코드:",
		"verify_msg": "인증 코드를 입력하세요",
		"inPlease_enter_the": "들어 오세요",
		"phone": "휴대폰",
		"No": "번호",
		"determine": "결정",
		"receive": "받다",
		"Image_preview": "아바타 미리보기",
		"Install": "지금 설치",
		"obtain": "축하합니다",
		"check_update": "업데이트 확인 중 ...",
		"real_name": "실제 이름",
		"tips": "나쁜 게임에 저항하고 해적판 게임을 거부하십시오. 자기 보호에주의를 기울이고 속지 않도록주의하십시오. 중간 정도의 게임은 두뇌에 도움이되고 게임 음료를 즐기십시오. 합리적으로 시간을 정하고 건강한 삶을 즐기십시오.",
		"tishi": "신속한",
		"no_data": "데이터 없음",
		"queding": "결정",
		"quxiao": "취소",
		"download_new_version": "이 기능을 사용하려면 최신 버전의 앱을 다운로드하세요.",
		"online_kefu": "온라인 서비스",
		"save_account": "계정 정보 저장",
	},

	"data_req_text": {
		"login_failure": "로그인이 만료되었습니다. 다시 로그인하십시오.",
	},

	"login_text": {
		"account_pro": "계좌 번호는 비워 둘 수 없습니다. 입력하십시오!",
		"psw_pro": "비밀번호는 비워 둘 수 없습니다. 입력 해주세요!",
		"vfy_pro": "인증 코드는 비워 둘 수 없습니다. 입력 해주세요!",
		"quick_login_fail": "게스트 로그인 실패",
		"account": "계좌 번호:",
		"account_msg": "계좌 / 전화 번호를 입력하세요",
		"paw_msg": "비밀번호를 입력 해주세요",
		"Remember_acc": "날 기억해",
		"forget_paw": "비밀번호 분실?",
		"no_acc": "계정이 없습니다.",
		"go_reg": "등록으로 이동>",
		"confirm_login": "로그인 확인",
		"quick_login": "빠른 로그인",
		"confirm_register": "등록 확인",
		"register_cg": "등록 성공",
		"account_data": "계정 정보",
        "sfyz": "인증",
        "sfyz_tip": "존경 하 는 고객 님 안녕하세요!계 정 보안 을 위해 서 이번 로그 인 은 악성 프로그램 이 자동 으로 로그 인 되 는 것 을 방지 하기 위해 다음 과 같은 검증 이 필요 합 니 다.",
        "bind_bank": "바 인 딩 된 카드 를 입력 하 세 요",
        "bind_alipay": "귀속 한 알 리 페 이 를 입력 하 세 요",
        "bank_card": "은행 카드:",
        "alipay": "알 리 페 이:",
        "code": "인증번호:",
        "enter_bank_card": "카드 번 호 를 입력 하 세 요",
        "enter_alipay": "알 리 페 이 계 정 을 입력 하 세 요",
        "enter_code": "인증번호 입력",
	},

	"register_text": {
		"perfect_suc": "정보를 성공적으로 완료하십시오!",
		"perfect_err": "완전한 데이터가 실패했습니다!",
		"inp_data": "먼저 정보를 입력하세요!",
		"inp_email": "이메일을 입력 해주세요",
		"inp_phone": "전화 번호를 입력하세요",
		"inp_wx": "WeChat ID를 입력하십시오",
		"inp_qq": "QQ 번호를 입력하십시오",
		"email": "사서함:",
		"wx_No": "위챗 :",
		"qq_No": "QQ 번호 :",
		"phone": "전화 번호:",
		"user_name": "사용자 이름:",
		"user_msg": "6-12 자리 문자 또는 숫자 계정을 입력하세요",
		"user_pro": "6-12 문자 또는 숫자 또는 기호의 비밀번호",
		"paw_pro": "비밀번호는 6-12 자리 숫자와 문자의 조합입니다.",
		"confirm_paw_pro": "확인 비밀번호는 비워 둘 수 없습니다. 입력 해주세요!",
		"paw_consistent": "비밀번호와 확인 된 비밀번호가 일치하지 않습니다. 다시 입력하세요!",
		"paw_msg": "6-12 개의 문자와 숫자로 비밀번호를 입력하세요.",
		"confirm_msg": "암호를 다시 확인하십시오",
		"phone_msg": "전화 인증 코드를 입력하세요",
		"con_paw": "비밀번호 확인:",
		"exi_acc": "이미 계정이 있습니다.",
		"go_log": "로그인으로 이동>",
		"send_verify": "보내다",
		"retry_verify": "재전송",
		"phone_confirm": "정확한 전화 번호를 입력하세요!",
		"register_suc": "등록 성공!",
		"user_not_mag": "사용자 이름은 비워 둘 수 없습니다. 입력하십시오!",
		"No_null": "숫자는 비워 둘 수 없습니다. 입력 해주세요!",
		"correct_phone": "정확한 전화 번호를 입력하세요!",
		"phone_vfy": "전화 인증 코드는 비워 둘 수 없습니다. 입력하세요!",
		"loss_account": "계정 분실을 방지하기 위해 계정을 저장하세요.",
		"account_change": "계정은 한 번만 수정할 수 있습니다. 수정을 클릭하십시오.",
		"please_tick": "계정 비밀번호를 확인하려면 체크 버튼을 클릭하세요!",
		"save_suc": "성공적으로 저장되었습니다!",
		"save_err": "저장하지 못했습니다!수동으로 스크린 샷을 찍으십시오！",

		"currency": "통화:",
		"language": "언어:",

	},

	"datum_text": {
		"datum_title": "정보 제출",
		"bank_card": "은행 카드 번호 :",
		"inPlease_enter_the": "들어 오세요...",
		"input_datum": "먼저 데이터를 입력하십시오",
		"update_img": "이미지 업로드",
		"select_update_img": "업로드 된 사진을 선택하세요",
		"limit_type": "JPG, JPEG, PNG 만 업로드 가능",
		"msg_update_data": "먼저 데이터를 업로드하십시오",
		"mag_update_pic": "먼저 올바른 형식으로 사진을 업로드하세요.",
		"apply_succ": "신청서가 성공적으로 제출되었습니다. 검토를 기다리십시오.",
	},

	"task_text": {
		"activity": "활동",
		"task": "직무",
		"announcement": "발표",
		"sign": "로그인",
		"task_name": "임무 이름 :",
		"task_detail": "작업 세부 정보",
		"task_time": "작업 유효 시간 :",
		"task_content": "작업 내용 :",
	},

	"customer_text": {
		"jump_whatsapp": "whatsapp 계정이 성공적으로 복사되었습니다. whatsapp 으로 리디렉션 요청",
		"jump_telegram": "telegram 계정이 성공적으로 복사되었습니다. telegram 으로 리디렉션 요청",
		"jump_Messenger": "Messenger 계정이 성공적으로 복사되었습니다. Messenger 으로 리디렉션 요청",
		"jump_Viber": "Viber 계정이 성공적으로 복사되었습니다. Viber 으로 리디렉션 요청",
		"no_whatsapp": "장치에 whatsapp 이 설치되어 있지 않습니다.",
		"no_telegram": "장치에 telegram 이 설치되어 있지 않습니다.",
		"no_Messenger": "장치에 Messenger 이 설치되어 있지 않습니다.",
		"no_Viber": "장치에 Viber 이 설치되어 있지 않습니다.",

		"contact_customer": "고객 서비스에 문의",
		"not_ind_qq": "QQ가 장치에 설치되어 있지 않습니다.",
		"jump_wx": "WeChat 계정이 성공적으로 복사되었습니다. WeChat으로 리디렉션 요청",
		"not_ind_wx": "장치에 WeChat이 설치되어 있지 않습니다.",
		"jump_mt": "MT 고객 서비스 계정이 성공적으로 복사되었습니다. MT 고객 서비스를 리디렉션하도록 요청하십시오.",
		"Online": "온라인 서비스",
		"QQ": "QQ 고객 서비스",
		"WECHAT": "WeChat 고객 서비스",
		"MT": "MT 고객 서비스",
		"CJ": "일반적인 문제",
		"contact_online": "고객 서비스에 문의",
		"copy_wx": "WeChat ID 복사",
		"copy_mt": "MT 번호 복사",
	},

	"msg_text": {
		"save_date": "메시지는 최대 1 개월 동안 저장됩니다.",
		"message": "뉴스",
		"email": "우편",
		"receive": "받은",
		"overdue": "만료",
		"not_delete": "삭제할 수 없습니다. 먼저 보상을 받으십시오.",
		"not_be_deleted": "요청되지 않은 메일은 삭제되지 않습니다.",
	},

	"basic_text": {
		"basic_title": "기본 정보",
		"account": "계좌 번호:",
		"nickname": "별명:",
		"name": "이름:",
		"com_title": "통신 정보",
		"qq": "Q Q :",
		"wx": "위챗 :",
		"phone": "휴대폰 :",
		"email": "우편함 :",
	},

	"baes_text": {
		"unit": "원",
		"view": "전망",
		"yes": "예",
		"no": "아니",
		"update": "최신 정보",
		"cancel": "취소",
		"mail_system": "시스템 메일",
		"connected": "연결 중입니다. 잠시만 기다려주세요 ...",
		"coin": "금",
	},

	"pre_details_text": {
		"detail": "충전 정보",
		"lxkf": "고객 서비스에 문의",
		"rkz": "입금 중 ...",
		"copy": "부",
		"order": "주문 번호",
		"date": "재충전 시간",
		"czType": "충전 방법",
		"transfer": "이전",
		"succ": "성공",
		"error": "실패",
		"audit": "검토 중",
		"czSucc": "충전 실패",
		"copy_succ": "성공적으로 복사",
		"order_num": "주문 번호",
	},

	"USDT_text": {
		"second_step": "2 단계 : USDT 체인 정보",
		"url_name": "체인 명",
		"alipay": "알리 페이로 결제",
		"url": "체인 주소 ...",
	},

	"set_text": {
		"set_music": "음악 설정",
		"switch_music": "음악 전환",
		"change_d_paw": "로그인 비밀번호 수정",
		"change_t_paw": "출금 비밀번호 수정",
		"version": "현재 버전",
		"huidu": "그레이 스케일",
		"swi_test": "베타 버전으로 전환 하시겠습니까?",
		"swi_hui": "그레이 스케일 버전으로 전환할지 여부",
		"old_paw_null": "이전 비밀번호는 비워 둘 수 없습니다. 입력 해주세요!",
		"new_paw_null": "새 비밀번호는 비워 둘 수 없습니다. 입력 해주세요!",
		"old_paw_limit_length": "이전 비밀번호는 6 ~ 12 자리입니다.",
		"new_paw_limit_length": "새 비밀번호는 6-12 자리 숫자와 문자의 조합입니다.",
		"new_paw_limit": "이전 비밀번호는 6 자리 숫자 여야합니다. 다시 입력하세요.",
		"con_paw_null": "확인 비밀번호는 비워 둘 수 없습니다. 입력 해주세요!",
		"con_paw_consistent": "비밀번호와 확인 된 비밀번호가 일치하지 않습니다. 다시 입력하세요!",
		"new_old_paw_consistent": "새 암호는 이전 암호와 같을 수 없습니다. 다시 입력하십시오!",
		"change_succ": "축하합니다. 성공적으로 암호를 변경했습니다. 다시 로그인하십시오!",
		"tx_paw_null": "출금 비밀번호는 비워 둘 수 없습니다.",
		"con_tx_paw": "출금 비밀번호는 비워 둘 수 없습니다. 입력 해주세요.",
		"tx_paw_consistent": "출금 비밀번호가 확인 비밀번호와 일치하지 않습니다. 확인하세요.",
		"tx_paw_limit": "출금 비밀번호는 6 자리 숫자로 입력 해주세요.",
		"paw_change_succ": "축하합니다. 비밀번호를 성공적으로 변경했습니다.",
		"latest_version": "최신 버전의 앱입니다.",
		"switch_server": "서버 전환",
		"switch_language": "언어 전환",
		"change_language_tips": "일부 페이지의 언어는 응용 프로그램을 다시 시작한 후에 적용됩니다.",
		"restart": "재부팅",
	},

	"share_text": {
		"copy_wa": "복사 복사",
		"save_img": "사진을 저장하다",
		"share_py": "친구 서클 공유",
		"submit_audit": "리뷰 제출",
		"copy_succ": "성공적으로 복사",
		"save_img_succ": "사진을 성공적으로 저장",
		"save_err": "사진을 저장하지 못했습니다. 이 응용 프로그램의 사진 저장 권한을 열려면 전화 설정 페이지로 이동하십시오.",
		"share_go": "공유 :",
		"share_err_qq": "공유에 실패했습니다. QQ를 설치하거나 확인한 후 다시 시도하십시오.",
		"share_err_wx": "공유에 실패했습니다. WeChat을 설치하거나 확인한 후 다시 시도하십시오.",
		"share_err_wl": "바인딩에 실패했습니다. 네트워크를 확인하고 다시 시도하십시오.",
		"shareIntroduce_title": "튜토리얼 공유",
		"inviteFriends": "친구를 초대",
	},

	"hot_text": {
		"dzyx": "세계적인 인기 비디오 게임을 모아서 열정이 줄어들지 않고 승률이 높아집니다. 천만 개의 선물이 여러분을 기다리고 있습니다!",
		"qbyx": "세계에서 가장 인기있는 보드 게임을 모아서 인기가 떨어지지 않고 승률이 높아지고 수천만 개의 선물을받을 수 있습니다!",
		"byyx": "세계에서 가장 인기있는 낚시 게임을 모아서 열정이 떨어지지 않고 승률이 높아집니다.",
		"rmqp": "인기있는 체스",
		"rmdz": "인기 전자 제품",
		"rmby": "인기 낚시",
		"ljyx": "지금 플레이",
	},

	"agent_text": {
		"my_id": "내 ID :",
		"under": "어제의 직접 커미션 :",
		"offline": "어제 오프라인 수수료 :",
		"under_player": "다이렉트 플레이어 :",
		"day_new": "어제 추가 :",
		"offline_player": "오프라인 플레이어 :",
		"bind_wx": "WeChat에 바인딩",
		"share_rewards": "보상 공유 :",
		"commission_ins": "수수료 정산 일은 일일 정산으로 친구 나 친구들과 공유하면 보상을 나눌 수 있습니다!",
	},

	"vip_text": {
		"title": "내 VIP",
		"backToMe": "내로 돌아 가기",
		"me": "나는",
		"my_level": "내 레벨 :",
		"current_code": "현재 코딩 량 :",
		"was_filed": "프로모션 잭팟",
		"was_filed_info": "진행하면 보너스를받을 수 있습니다",
		"weeks_amounts": "저우 리진",
		"weeks_amounts_info": "매주 월요일 무료 배포",
		"month_amounts": "월간 선물",
		"month_amounts_info": "매월 1 일 정시에 배포",
		"wash_code": "세탁 코드",
		"wash_code_info": "최대 세탁 코드 비율",
		"but_text": "지금 이동",
		"get_error": "금화 획득에 실패했습니다. 금화를 다시 새로 고침하세요!",
		"amount_code": "코드 금액",
	},

	"xima_text": {
		"game_type": "게임 타입",
		"dm_total": "효과적인 베팅 금액",
		"proportion": "최대 세탁 코드 비율",
		"xm_amount": "세탁 코드 양",
		"can_led_take": " 유효한",
		"xm_total": "총 세탁량",
	},

	"PlayerCenter": {
		"jbxx": "기본 정보",
		"zhmx": "계정 정보",
		"zdlb": "베팅 목록",
		"my_vip": "내 VIP",
		"save": "저장",
		"edit": "편집하다",
		"note": "비고",
		"betting_record": "베팅 기록",
		"trading_hours": "거래 시간",
		"trading_type": "거래 유형",
		"change_amount": "금액 변경",
		"balance": "밸런스",
		"today": "요즘",
		"yesterday": "어제",
		"a_month": "한 달",
		"all": "모두",
		"status": "거래 상태",
		"chess": "체스",
		"send_time": "지불 시간",
		"note_num": "게임 베팅 번호",
		"betting_amount": "베팅 금액",
		"has_been": "수상",
		"gaming": "게임 플랫폼",

		"currencyType": "통화 변환",
		"rate": "환율",
	},

	"RechargeLayer": {
		"note": "비고",
		"often_play": "플레이어가 자주 플레이하는 빠른 금액",
		"between": "1에서 100 사이의 금액을 입력하세요.",
		"gift100": "100 % 무료",
		"payment_account": "수신 계정",
		"payee": "수취인",
		"where": "계좌 은행",
		"depositors": "입금자의 실명을 입력 해주세요.",
		"note_info": "비고 정보",
		"step": "첫 번째 단계 : 결제 및 충전의 QR 코드를 스캔",
		"step2": "2 단계 : 충전 정보 입력 및 충전 제출",
		"session": "최근 대화",
		"official": "공식 인증",
		"gift2": "2 % 무료",
		"channel": "* 추가 채널을 선택하세요. \ n * 채널을 선택하기 전에 환율을주의 깊게 확인하세요.",
		"qr_code": "저장 \ n 저장 \ n 두 \ n 크기 \ n 코드",
		"digital_currency": "디지털 화폐 충전 채널 1",
		"step_1": "1 단계 : USDT 금액 선택",
		"formula": "최종 재충전 계산 공식 : 70.86 = 10.1234USDT * 현재 환율 7 위안",
		"step3": "3 단계 : 출금 정보 제공",
		"actual_account": "받은 USDT의 실제 금액",
		"poundage": "수수료 0-50USDT",
		"instr": "* 왼쪽 그림과 같이 정확하게 입력 해주세요! \ n * 잘못 입력하시면 정시에 도착하실 수 없습니다!",
		"not_account": "충전이 아직 도착하지 않았습니까?",
		"rate": "환율 : 1USDT = 99 위안",
		"prompt_info": "프롬프트 정보",
		"czjl": "재충전 기록",
		"czjc": "충전 튜토리얼",
		"ljcz": "지금 충전",
		"czje": "충전량",
		"zfpz": "지불 바우처",
		"save_code": "QR 코드 저장",
		"xuanchuan": "공식 에이전트 재충전 \ n 절대적인 평판 보장",
		"usdt_address": "USDT 입금 주소 :",
		"syb": "이전",
		"complete": "수행하다",
		"usdt_num": "USDT 금액 재충전 :",
		"go_recharge": "위로 가기",
		"back": "반환",
		"creat_order": "주문 생성",
		"real_usdt": "받은 USDT의 실제 금액",
		"sxf": "수수료",
		"date": "시각",
		"state": "상태",
		"jine": "양",
		"detail": "세부",
		"rechargeCourse": "충전 튜토리얼",
		"rate2coin": "환율 : 금화 1 개 =",
		"currency_symbol": "¥",
		"currency_word": "RMB",
		"get_coins": "받은 금화 :",
		"get_money": "받은 금액 :",
		"go_pay": "복사가 완료되었습니다. 즉시 결제 하시겠습니까?",
		"pay_now": "즉시 지불",
		"pay_not_support": "일시적으로 결제 할 수 없습니다!",
	},

	"SettingLayer": {
		"bind_equi": "장치 바인딩",
		"basic_info": "기본 정보",
		"account": "계좌 번호:",
		"level": "수평:",
		"set_sound": "사운드 설정",
		"music": "음악",
		"sound": "음향 효과",
		"switch_music": "음악 전환",
		"song2": "죽을 때 사랑해야 해",
		"song1": "노래 1",
		"inp_landing_paw": "비밀번호를 입력하세요",
		"inp_old_paw": "이전 비밀번호를 입력하세요",
		"old_paw": "기존 비밀번호:",
		"inp_new_paw": "새 비밀번호를 입력하세요",
		"new_paw": "새 비밀번호:",
		"con_new_paw": "새 비밀번호 확인",
		"con_paw": "비밀번호 확인:",
		"check_update": "업데이트 확인",
		"determine": "결정",
		"bind_shuom1": "* 장치 바인딩 후 빠른 로그인을 사용하여 바인딩 된 장치에 직접 로그인 할 수 있습니다.",
		"bind_shuom2": "* 계정을 등록하기 위해 빠르게 로그인하면 현재 장치가 자동으로 바인딩됩니다.",
		"bind_shuom3": "* 장치 바인딩 후 신원 확인 및 바인딩 해제가 가능합니다.",
		"bind_shuom4": "* 본인 확인을 위해 계정의 로그인 비밀번호를 입력해야합니다.",
		"bind_shuom5": "*주의해서 사용하십시오!",
		"bind_shuom6": "현재 장치가 바인딩되었습니다.",
		"bind_shuom7": "이미 바인딩 된 다른 장치",
		"landing_paw": "로그인 비밀번호:",
		"test": "테스트 환경",
		"huidu": "그레이 스케일 환경",
		"standbyTest": "대체 테스트 환경",
		"mute_all": "모두 음소거",
		"change_account": "계정 전환",
		"confirm_change": "변경 사항 확인",
		"confirm_bind": "장치 바인딩",
		"unbind_device": "장치 바인딩 해제",
		"unbind": "바인딩 해제",
	},

	"Task": {
		"share_task": "작업 공유",
		"MG_electronic": "MG 전자",
		"cash": "현금",
		"complete": "끝내기 위해",
		"application": "지원",
		"refused": "거부",
		"disclose_data": "정보 제출",
		"submit": "제출",
		"Audit_failure": "감사 실패",
		"friends_account": "스크린 샷 제출",
		"apply_reward": "보상 신청",
		"pic_limit": "JPG, JPEG, PNG 만 업로드 할 수 있으며 1M 이하",
		"btn_choose": "고르다",
		"update_pic": "이미지 업로드:",
		"editTips": "업로드 된 사진을 선택하세요",
		"task_details": "작업 세부 정보",
		"Task_details": "작업 세부 정보 :",
		"task_name": "임무 이름 :",
		"task_state": "과업 설명:",
		"share": "그것을 공유",
		"task_progress": "작업 진행 :",
		"know": "알아",
		"q_update_pic": "먼저 사진을 업로드하세요",
		"activit_Shut": "작업 활동이 마감되었습니다.",
		"Qbind_wx": "먼저 WeChat을 바인딩하십시오",
		"Application_success": "신청이 완료되었습니다. 검토를 기다려주세요.",
		"Succ_application_Award": "보상 신청 성공",
		"task_ShutDown": "공유 작업이 종료되었습니다.",
	},

	"ThirdGamesListLayer": {
		"xsj": "새로운 세계 체스",
		"tall_game": "총 1 경기",
		"inp_game": "게임 이름을 입력하세요",
	},

	"TuiGuangLayer": {
		"title": "진흥 기관",
		"my_agent": "내 에이전트",
		"agent_recruit": "에이전트 모집",
		"agent_introduced": "에이전트 소개",
		"players_query": "플레이어 쿼리",
		"results_query": "성능 쿼리",
		"rich_list": "부 목록",
		"my_id": "내 ID :",
		"under": "어제의 직접 커미션 :",
		"offline": "어제 오프라인 수수료 :",
		"under_player": "다이렉트 플레이어 :",
		"day_new": "어제 추가 :",
		"offline_player": "오프라인 플레이어 :",
		"share_rewards": "보상 공유 :",
		"commission_ins": "수수료 정산 일은 일일 정산으로 친구 나 친구들과 공유하면 보상을 나눌 수 있습니다!",
		"save_qr_code": "QR 코드 저장",
		"copy": "부",
		"bind_wx": "WeChat에 바인딩",
		"Imm_receive": "지금 당장 받아",
		"share_detail": "세부 정보 공유",
		"get_record": "수집 기록",
		"historyCom": "역사적 총 수수료",
		"canReceive": "미수금",
		"zhishu_renshu": "부하 직원 수 :",
		"tall_bets_today": "오늘 총 효과적인 베팅 :",
		"inp_id": "아이디를 입력하세요",
		"query": "조회",
		"reset": "초기화",
		"bets_today": "오늘 유효한 베팅",
		"total_bets": "총 효과적인 베팅",
		"directly_num": "부하 직원 수",
		"operation": "운영",
		"details": "세부 사항 >>",
		"date": "데이트",
		"under_new": "직접 추가",
		"team_new": "새로운 팀",
		"directly_under": "직접 커미션 리베이트",
		"total_amount": "총 리베이트",
		"reward": "보상",
		"contact": "튜터에게 연락",
		"ranking": "계급",
		"player_info": "선수 정보",
		"rebate_month": "이번 달 커미션 리베이트",
		"rewards_month": "이번 달 보상 공유",
		"detailed_info": "세부",
		"zhuce_shijian": "등록 시간 :",
		"jtyxtz": "오늘 유효한 베팅 :",
		"tdrsxz": "팀 수 (신규) :",
		"jrtdyxtz": "오늘의 팀 유효 베팅 :",
		"directly_num_new": "부하 직원 수 (신규) :",
		"zuoriyongjing": "어제의 커미션 :",
		"commission_payable": "인출 가능 수수료 :",
		"lishizongyong": "역사적 총 커미션 :",
		"zyxtz": "총 효과적인 베팅 :",
		"agent_commission": "대행사 수수료",
		"share_commission": "수수료 공유",
		"team_num": "팀 규모",
		"not_directly_under": "간접 리베이트",
		"account": "계좌 번호",
		"between": "관계",
		"effective_betting": "효과적인 베팅 / 리베이트 금액",
		"ratio": "리베이트 비율",
		"total": "합계",
		"share": "그것을 공유",
	},

	"WithdrawLayer": {
		"self_help": "셀프 서비스 철회",
		"withdrawal_record": "출금 기록",
		"wallet_management": "지갑 관리",
		"inp_withdrawal_amount": "출금 금액을 입력하세요",
		"warm_prompt": "팁",
		"current_need_adjust_amount": "현금을 인출하려면 <color = # 00ff00> 0 </ c> 흐름이 필요합니다.",
		"current_need": "여전히 필요",
		"can_carry": "인출 전 흐르는 물",
		"adjust_amount": "인출 금액을 조정하려면 점을 드래그하세요.",
		"bank": "ICBC",
		"change_bank_card": "은행 카드 변경",
		"not_bind_card": "아직 은행 카드를 제본하지 않았습니다. 제본으로 이동하십시오.",
		"not_tixian_paw": "출금 비밀번호를 설정하지 않았습니다. 먼저 출금 비밀번호를 설정하세요.",
		"tixian_paw": "비밀번호 철회",
		"set6num_paw": "6 자리 비밀번호를 설정하세요",
		"confirm_password": "비밀번호 확인",
		"again_confirm_password": "확인하려면 비밀번호를 다시 입력하세요.",
		"inp_tixian_paw": "출금 비밀번호를 입력하세요",
		"topUp_failure": "충전 실패",
		"bank_paragraph": "은행 인출",
		"add_card": "은행 카드 추가",
		"cardholder_name": "카드 소지자의 이름을 입력하세요",
		"cardholder": "카드 소지자 :",
		"card_code": "은행 카드 계좌 번호 :",
		"inp_bank_card_code": "은행 카드 번호를 입력하십시오",
		"inp_bank_address": "은행 주소를 입력하십시오",
		"bank_address": "계좌 개설 주소 :",
		"bank_address_msg": "팁 : 계좌 은행을 정확히 선택하고 실명을 제본하십시오. 계좌는 정산시 계좌로 직접 이체됩니다. 자금의 안전을 위해 제본 후 임의로 변경할 수 없습니다. 수정이 필요한 경우 고객 센터로 문의하시기 바랍니다.",
		"choose_bank": "은행 선택 :",
		"inp_aliPay_name": "Alipay의 실명을 입력하세요",
		"inp_aliPay_code": "Alipay 계정을 입력하십시오",
		"name": "이름:",
		"aliPay_account": "Alipay 계정 :",
		"aliPay_account_msg": "Tips : Alipay를 정확히 선택하시면 정산시 변경된 계좌로 바로 이체됩니다. 자금의 안전을 위해 구속력이있는 후에는 임의로 변경할 수 없습니다. 수정이 필요한 경우 고객 센터로 문의하시기 바랍니다.",
		"inp_tixian_dizhi": "출금 주소를 입력하세요",
		"rate": "환율",
		"daozhangUSDT": "받은 USDT 금액",
		"confirm_tixian": "출금 확인",
		"max": "최고",
		"confirm_submit": "제출 확인",
		"tixian_time": "출금 시간",
		"jine": "양",
		"state": "상태",
		"order_info": "주문 정보",
		"confirm_bind": "바인딩 결정",
		"confirm_select": "선택 확인",
		"select_bank_card": "은행 카드 선택",
		"bizhong_xuanze": "통화 선택 :",
		"tixian_dizhi": "출금 주소 :",
		"more_than_0": "인출 금액은 0보다 커야합니다.",
	},

	"XimaLayer": {
		"title": "세탁 코드",
		"selfHelp_washing": "자가 세척 코드",
		"xima_record": "세탁 코드 기록",
		"xima_proportion": "세척 코드 비율",
		"fishing_game": "낚시 게임",
		"to_complete": "끝내기 위해",
		"receive": "받다",
		"chess": "체스",
		"fishing": "어업",
		"electronic": "전자",
		"reality": "실제 사람",
		"sports": "체육",
		"eSports": "노름",
		"lottery": "운",
		"game": "경기",
		"key_get": "원 클릭 컬렉션",
		"get_time": "수집 시간",
		"damaliang": "효과적인 베팅 금액",
		"xima_amount": "세탁 코드 양",
		"details": "세부",
		"viewI": "보기 >>",
		"xima_details": "코드 세척 세부 사항",
		"heitao_chess": "스페이드 한 벌",
		"chess_game": "보드 게임",
		"sports_events": "스포츠 이벤트",
		"electronic_game": "전자 게임",
		"lottery_betting": "복권 베팅",
		"real_video": "라이브 비디오",
		"eSports_game": "E- 스포츠 게임",
		"game_name": "게임 명",
		"click_details": "자세한 내용을 보려면 클릭하세요",
		"tianmei_chess": "톈 메이 체스",
		"detailsI": "세부 사항 >>",
		"xima_range": "코드 세척 범위",
		"vip_level": "VIP 레벨",
		"tournament": "E- 스포츠",
		"lottery_game": "복권 게임",
	},

	"Signal": {
		"switch": "라인 전환",
		"speed": "가속 라인",
		"choose": "라인 선택",
		"reconnect": "다시 연결",
		"helpful_hints": "친절한 알림 : 지연이 낮을수록 네트워크가 좋아집니다.",
		"is_msg": "이것은 메시지입니다",
		"in_test": "확인 중",
		"general": "일반",
		"smooth": "부드러운",
		"speed1": "속도",
		"current_use": "현재 사용",
	},

	"general": {
		"name": "이름",
		"activity": "포괄적 인 활동",
		"xzsm": "주소 발급자, 언제든지 최신 설치 주소를 받으십시오.",
		"wszl": "완전한 재료",
		"qdcj": "로그인 보너스",
		"xtyj": "시스템 메일",
		"xxzx": "메시지 센터",
		"bt": "표제",
		"sj": "시각",
		"nr": "함유량",
		"xx": "뉴스",
		"dlq": "보류 중",
		"ylq": "받은",
		"ygq": "만료",
		"ready_all": "모두 읽음",
		"del_all": "모두 삭제",
		"get_all": "모두 청구",
	},

	"EllipticalStage": {
		"musicNmae": "승리를 위해",
	},

	"CheckHot": {
		"update_msg": "새 버전 업데이트가 감지되고 다운로드가 완료되었습니다. 업데이트를 완료하려면 클릭하세요!",
		"update": "최신 정보",
		"lack_resources": "예술 자원 부족",
		"kaiyuan_chess": "카이 위안 체스",
		"leyou_chess": "르 투르 체스",
		"xinshijie_chess": "새로운 세계 체스",
		"ag_electronic": "AG 전자",
		"pg_electronic": "PG 전자",
		"mg_electronic": "MG 전자",
	},

	"HallUI": {
		"copy_succ": "성공적으로 복사",
		"moment_open": "아직 열리지 않음",
		"no_announcement": "공지 내용 없음",
		"tmpled_err": "템플릿 구성 오류입니다. 고객 서비스에 문의하십시오.",
		"game_maintain": "게임이 점검 중입니다",
		"game_loading": "게임이로드 중입니다",
		"get_err": "금화 획득에 실패했습니다. 금화를 다시 새로 고침하세요!",
		"login": "로그인",
		"register": "등기",
		"copy_id": "ID 복사",
		"huodong": "활동",
		"task": "직무",
		"setting": "설정",
		"remen": "인기 있는",
		"qipai": "체스",
		"buyu": "어업",
		"zhenren": "실제 사람",
		"dianzi": "전자",
		"tiyu": "체육",
		"caipiao": "운",
		"dianjing": "노름",
		"tuiguangdaili": "진흥 기관",
		"xima": "세탁 코드",
		"xiaoxi": "뉴스",
		"kefu": "고객 서비스",
		"xiufugongju": "수리 도구",
		"gengduo": "더",
		"qiandao": "로그인",
		"paihangbang": "리더 보드",
		"gonggao": "발표",
		"tixian": "빼다",
		"chongzhi": "재충전",
		"xianshilingqu": "기간 한정 수집",
		"remenyouxi": "최고 게임",
		"zuijingchangwan": "최근에 재생 된",
		"play_now": "지금 내기",
	},

	"BasicsJS": {
		"tall": "전체적으로",
		"minGame": "작은 게임",
		"play_game": "최근에 한 게임 없음",
		"editor_succ": "성공적으로 편집",
		"yi_bind": "경계",
		"wu_bind": "매여 있지 않은",
		"inp_amount": "충전 금액을 입력하세요",
		"inp_correct_amount": "정확한 재충전 금액을 입력하십시오",
		"no_login_yinshang": "미등록 은행 가맹점",
		"gift": "선물",
		"voucher_cannot_empty": "결제 바우처는 비워 둘 수 없습니다.",
		"pic_loading": "사진로드 중",
		"amount_between": "사이 금액",
		"card": "카드",
		"note_info": "비고 정보를 입력하고 계정에 더 빨리 액세스하십시오.",
		"credit_cord": "수신 카드 번호",
		"rate": "환율",
		"not_channel": "충전 채널이 없습니다. 고객 서비스에 문의하십시오.",
		"select_amount": "충전량을 선택하세요",
		"confirm_cancellation_order": "주문을 취소 하시겠습니까?",
		"been_submit": "주문이 제출되었습니다. 잠시 기다려주십시오.",
		"Eventually_topUp_amount": "계정 금액에 대한 최종 재충전은 다음과 같습니다.",
		"current_rate": "현재 환율",
		"Outstanding_orders": "계속할지 여부에 따라 완료되지 않은 주문이 있습니다.",
		"Continue": "계속하다",
		"Cancel_order": "주문 취소",
		"bind_succ": "성공적으로 바인딩",
		"inp_paw": "먼저 비밀번호를 입력하세요",
		"remove_bind_succ": "성공적으로 바인딩 해제",
		"first": "먼저",
		"day": "일",
		"Sports_eSports": "스포츠 E- 스포츠",
		"directly": "바로 아래",
		"not_directly": "바로 아래에",
		"amount_not_null": "인출 금액은 비워 둘 수 없습니다.",
		"WithdrawalAmount": "출금 금액",
		"Qbind": "먼저 바인딩하십시오",
		"moment_not_bind": "현재 바인딩되어 있지 않습니다.",
		"QgoBind": "바인딩하러 가세요",
		"replace": "바꾸다",
		"between": "중에서",
		"request_submit": "출금 요청이 제출되었습니다",
		"ContinueToCarry": "계속 인출",
		"GiveUpWithdrawal": "인출 종료",
		"Qxuanding": "팁 : 올바르게 선택하십시오",
		"jiesuanshihou": "여기로 직접 전송됩니다.",
		"zhuanghaowanquan": "계좌 번호는 자금의 안전을 위해 구속력이있는 후 임의로 변경할 수 없으며, 변경이 필요한 경우 고객 센터로 문의하시기 바랍니다.",
		"phoneNo": "전화 번호",
		"add": "추가",
		"updateTimeout": "업데이트 시간 초과를 확인하십시오. 네트워크가 정상인지 확인하십시오.",
		"retry": "다시 해 보다",
		"err_retry": "파일을 다운로드하는 중에 오류가 발생했습니다. 다시 시도하십시오.",
		"err_check_network": "네트워크가 중단되었습니다. 네트워크가 정상인지 확인하십시오.",
		"no_get_data": "리소스 업데이트가 없습니다. 나중에 다시 시도하십시오.",
		"network_retry": "네트워크 연결이 끊어졌습니다. 네트워크 연결이 정상인지 확인하세요.",
		"Quit_game": "게임 종료",
		"ReturnHall": "로비로 돌아 가기",
		"daozhangUSDT": "받은 USDT 금액",
	},
};